export default __webpack_public_path__ + "static/media/logo-toogether.7418f586.svg";